<template>
  <div>
    <main-layout>
      <v-tabs v-model="tabs" color="white" :slider-color="$store.state.theme.brand_color">
        <v-tab ripple :key="'overview'" :href="'#overview'">{{ $t('Overview') }}</v-tab>
        <v-tab ripple :key="'agentperformance'" :href="'#agentperformance'">{{
          $t('Agent performance')
        }}</v-tab>
        <v-tab ripple :key="'agentmanagement'" :href="'#agentmanagement'">{{
          $t('Agent Management')
        }}</v-tab>
        <!-- <v-tab ripple :key="'agent'" :href="'#agent'">{{ $t('Agent') }}</v-tab>
        <v-tab ripple :key="'funnel'" :href="'#funnel'">{{ $t('Funnel') }}</v-tab> -->
      </v-tabs>

      <div v-if="!loading">
        <div v-if="tabs == 'overview'">
          <Overview></Overview>
        </div>
        <div v-if="tabs == 'agentmanagement'">
          <Users></Users>
        </div>
        <div v-if="tabs == 'agentperformance'">
          <Agentperformance></Agentperformance>
        </div>
      </div>
    </main-layout>
  </div>
</template>

<script>
import Users from './Users.vue'
import Overview from './Overview.vue'
import Agentperformance from './Agentperformance.vue'
export default {
  components: {
    Users,
    Agentperformance,
    Overview
  },
  data() {
    return {
      loading: false,
      tabs: 'overview'
    }
  },
  async created() {
    await this.$store.dispatch('loadAgentGroups')
    await this.$store.dispatch('loadAgentSubGroups')
    // let vm = this
    // if (vm.$route.query.tab) {
    //   vm.tabs = vm.$route.query.tab
    // } else {
    //   vm.tabs = 'product'
    // }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/ticket2/agentmanagement/main.vue